import { type StateCreator } from 'zustand';

export type AuthSlice = {
  accessToken: string | null;
  refreshToken: string | null;
  onAuthSuccess: ({
    accessToken,
    refreshToken,
  }: {
    accessToken: string;
    refreshToken: string;
  }) => void;
  clearAuth: () => void;
};

export const createAuthSlice: StateCreator<AuthSlice, [], [], AuthSlice> = (set) => ({
  accessToken: null,
  refreshToken: null,
  onAuthSuccess: (payload) => {
    set((state) => ({
      ...state,
      accessToken: payload.accessToken,
      refreshToken: payload.refreshToken,
    }));
  },

  clearAuth: () =>
    set((state) => ({
      ...state,
      accessToken: null,
      refreshToken: null,
    })),
});
